import { useQuery } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { getChatsConversationsIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useChatConversationQuery = (conversationId: number | null) =>
	useQuery({
		queryKey: ChatKeys.detail(conversationId),
		queryFn: processResponse(() => getChatsConversationsIdV2(conversationId!)),
		enabled: conversationId !== null,
		meta: { persist: false },
	});
